import type { GridT } from '@mentimeter/http-clients';
import dark2x2File from './grids/2x2.svg';
import light2x2File from './grids/2x2_for_dark_themes.svg';
import dark3x3File from './grids/3x3.svg';
import light3x3File from './grids/3x3_for_dark_themes.svg';
import dark4x4File from './grids/4x4.svg';
import light4x4File from './grids/4x4_for_dark_themes.svg';
import darkBCGFile from './grids/bcg.svg';
import lightBCGFile from './grids/bcg_for_dark_themes.svg';
import blankFile from './grids/blank.svg';
import darkBoxesFile from './grids/boxes.svg';
import lightBoxesFile from './grids/boxes_for_dark_themes.svg';
import darkMiddleBoxesFile from './grids/boxes_middle.svg';
import lightMiddleBoxesFile from './grids/boxes_middle_for_dark_themes.svg';
import darkTopBoxesFile from './grids/boxes_top.svg';
import lightTopBoxesFile from './grids/boxes_top_for_dark_themes.svg';
import darkFramesFile from './grids/frames.svg';
import lightFramesFile from './grids/frames_for_dark_themes.svg';
import darkVerticalFile from './grids/vertical.svg';
import lightVerticalFile from './grids/vertical_for_dark_themes.svg';

const dark2x2 = dark2x2File.src;
const light2x2 = light2x2File.src;
const dark3x3 = dark3x3File.src;
const light3x3 = light3x3File.src;
const dark4x4 = dark4x4File.src;
const light4x4 = light4x4File.src;
const darkBCG = darkBCGFile.src;
const lightBCG = lightBCGFile.src;
const blank = blankFile.src;
const darkBoxes = darkBoxesFile.src;
const lightBoxes = lightBoxesFile.src;
const darkMiddleBoxes = darkMiddleBoxesFile.src;
const lightMiddleBoxes = lightMiddleBoxesFile.src;
const darkTopBoxes = darkTopBoxesFile.src;
const lightTopBoxes = lightTopBoxesFile.src;
const darkFrames = darkFramesFile.src;
const lightFrames = lightFramesFile.src;
const darkVertical = darkVerticalFile.src;
const lightVertical = lightVerticalFile.src;

const UNAVAILABLE_RATING_GRID_IDS = [
  'risk_matrix',
  'adl_matrix',
  'min-waves',
  'max-waves-90',
  'max-waves',
  'min-waves-90',
];

const DEFAULT_GRID_ID = '2x2';

const UNAVAILABLE_RATING_GRIDS = UNAVAILABLE_RATING_GRID_IDS.map<GridT>(
  (id) => {
    return {
      id,
      type: 'default',
      name: 'Blank (default)',
      dark: blank,
      bright: blank,
      editable: false,
    };
  },
);

export const DEFAULT_RATING_GRIDS: Array<GridT> = [
  ...UNAVAILABLE_RATING_GRIDS,
  {
    id: 'blank',
    type: 'default',
    name: 'Blank (default)',
    dark: blank,
    bright: blank,
    editable: false,
  },
  {
    id: DEFAULT_GRID_ID,
    type: 'default',
    name: '2 by 2',
    dark: dark2x2,
    bright: light2x2,
    editable: false,
  },
  {
    id: '3x3',
    type: 'default',
    name: 'GE-McKinsey 9 Box Matrix',
    dark: dark3x3,
    bright: light3x3,
    editable: false,
  },
  {
    id: '4x4',
    type: 'default',
    name: '16 Box Matrix',
    dark: dark4x4,
    bright: light4x4,
    editable: false,
  },
  {
    id: 'boxes',
    type: 'default',
    name: 'Boxes',
    dark: darkBoxes,
    bright: lightBoxes,
    editable: false,
  },
  {
    id: 'frames',
    type: 'default',
    name: 'Frames',
    dark: darkFrames,
    bright: lightFrames,
    editable: false,
    rotation: 0,
  },
  {
    id: 'boxes_top',
    type: 'default',
    name: 'Boxes Top',
    dark: darkTopBoxes,
    bright: lightTopBoxes,
    editable: false,
    rotation: 0,
  },
  {
    id: 'boxes_middle',
    type: 'default',
    name: 'Boxes Middle',
    dark: darkMiddleBoxes,
    bright: lightMiddleBoxes,
    editable: false,
    rotation: 0,
  },
  {
    id: 'vertical',
    type: 'default',
    name: 'Vertical',
    dark: darkVertical,
    bright: lightVertical,
    editable: false,
    rotation: 0,
  },
  {
    id: 'bcg',
    type: 'default',
    name: 'BCG Matrix',
    dark: darkBCG,
    bright: lightBCG,
    editable: false,
  },
];

export const DEFAULT_RATING_GRID_IDS = DEFAULT_RATING_GRIDS.map((g) => g.id);

export const DEFAULT_GRID = DEFAULT_RATING_GRIDS.find(
  (g) => g.id === DEFAULT_GRID_ID,
)!;
